// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z7KO","delete":"styles_delete___7X9h","update":"styles_update__zaYSW","add":"styles_add__1hTTb"};